import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { RunningClubEvent, runningClubEventFromJson, RunningClubEventList, RunningClubEventPaginationFilterRequest, UpsertRunningClubEvent } from '@/models/running-club-event.model';
import { ClubEventParticipation, ClubEventParticipantsPaginationFilterRequest, clubEventParticipationFromJson } from '@/models/running-club-event-participation.model';
import { RunningClubCustomRole } from '@/models/running-club-custom-role.model';

export const getPagedRunningClubEvents = async (input: RunningClubEventPaginationFilterRequest): Promise<PagedResponseModel<RunningClubEventList>> => {
  return await getReq(createUrl("a/RunningClub/Event/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => runningClubEventFromJson<RunningClubEventList>(itm))
  }));
};

export const getRunningClubEventsLookup = async (input?: string, clubId?: number, page?: number): Promise<PaginatedSelectModel> => {
  const model: RunningClubEventPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false,
    runningClubId: clubId
  };
  return await getPagedRunningClubEvents(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getPagedRunningClubEventParticipants = async (
  input: ClubEventParticipantsPaginationFilterRequest
): Promise<PagedResponseModel<ClubEventParticipation>> => {
  return await getReq(createUrl("a/RunningClub/Event/UsersPagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => clubEventParticipationFromJson(itm))
  }));
};

export const getRunningClubCustomRolesByClub = async (
  clubId: number
): Promise<BaseResponseModel<RunningClubCustomRole[]>> => {
  return await getReq(createUrl(`a/RunningClub/CustomRole/ByClub/${clubId}`))
    .then((res: any) => res.data);
};

export const getRunningClubEvent = async (id: number): Promise<BaseResponseModel<RunningClubEvent>> => {
  return await getReq(createUrl(`a/RunningClub/Event/GetById/${id}`),
  ).then((res: any) => ({
    ...res.data,
    result: runningClubEventFromJson<RunningClubEvent>(res.data.result)
  }));
};

export const upsertRunningClubEvent = async (input: UpsertRunningClubEvent): Promise<BaseResponseModel<RunningClubEvent>> => {
  return await postReq(createUrl("a/RunningClub/Event/Upsert"),
    input
  ).then((res: any) => ({
    ...res.data,
    result: runningClubEventFromJson<RunningClubEvent>(res.data.result)
  }));
};

export const deleteRunningClubEvent = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/Event/Delete/${id}`),
  ).then((res: any) => res.data);
};

export const setRunningClubEventConfirmed = async (id: number, isConfirmed: boolean): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl(`a/RunningClub/Event/Confirm/${id}`), {}, { params: { isConfirmed } }).then((res: any) => res.data);
};

export interface ClubEventActivitySyncResult {
  eventId: number;
  matchedCount: number;
  linkedCount: number;
  skippedAlreadyLinkedCount: number;
  checkedInCount: number;
  heatCellCount: number;
}

/** Matches the event's route against synced activities and links the matching ones to it. */
export const syncRunningClubEventActivities = async (id: number): Promise<BaseResponseModel<ClubEventActivitySyncResult>> => {
  return await postReq(createUrl(`a/RunningClub/Event/SyncActivities/${id}`), {}).then((res: any) => res.data);
};
